export default "__VITE_ASSET__DgqQ8OP6__"